/**
 * Browser Logger Interface
 *
 * Abstracts logging so browser-core works in any environment:
 * - Cloud (apps/api): Wraps pino logger
 * - CLI (canary-cli): Uses console logger
 *
 * @module logger
 */

export interface BrowserLogger {
  debug(msg: string, data?: Record<string, unknown>): void;
  info(msg: string, data?: Record<string, unknown>): void;
  warn(msg: string, data?: Record<string, unknown>): void;
  error(msg: string, data?: Record<string, unknown>): void;
}

/**
 * Default console-based logger. Works everywhere without dependencies.
 */
export const consoleLogger: BrowserLogger = {
  debug: (msg, data) => {
    if (data) console.debug(msg, data);
    else console.debug(msg);
  },
  info: (msg, data) => {
    if (data) console.info(msg, data);
    else console.info(msg);
  },
  warn: (msg, data) => {
    if (data) console.warn(msg, data);
    else console.warn(msg);
  },
  error: (msg, data) => {
    if (data) console.error(msg, data);
    else console.error(msg);
  },
};
